import { Response } from '@marketplace-web/shared/api-client'

import { PhotoTipDto, PhotoTipModel, PhotoTipResp, PhotoTipsResp } from '../types/photo-tips'

export const transformPhotoTipDto = (photoTip: PhotoTipDto): PhotoTipModel => {
  const { id, title, body, entry_type, sorting_order, image_url } = photoTip

  return {
    id,
    title,
    body,
    entryType: entry_type,
    sortingOrder: sorting_order,
    imageUrl: image_url,
  }
}

export const transformPhotoTipDtos = (photoTips: Array<PhotoTipDto>): Array<PhotoTipModel> =>
  photoTips.map(transformPhotoTipDto)

export const transformPhotoTipResponse = (response: Response<PhotoTipResp>) =>
  transformPhotoTipDto(response.photo_tip)

export const transformPhotoTipsResponse = (response: Response<PhotoTipsResp>) =>
  transformPhotoTipDtos(response.photo_tips)
